'use client';

import { Alert, AlertDescription, AlertTitle, Button, FlexContainer } from '@bridge/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { create } from 'zustand';

import { faArrowsRotate } from '@icons/classic/regular';

interface ReleaseBannerState {
  isVisible: boolean;
  show: () => void;
}

const useReleaseBannerStore = create<ReleaseBannerState>((set) => ({
  isVisible: false,
  show: () => set({ isVisible: true }),
}));

export function showReleaseBanner() {
  useReleaseBannerStore.getState().show();
}

// Standalone fixed element (not a react-hot-toast toast) pinned below the z-50 modal/sheet
// overlay layer, so this persistent banner never covers their CTAs.
export function ReleaseBanner() {
  const isVisible = useReleaseBannerStore((state) => state.isVisible);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="animate-in slide-in-from-bottom fixed bottom-4 right-4 z-40 max-w-sm">
      <Alert className="shadow-lg">
        <AlertTitle>New version available</AlertTitle>
        <AlertDescription>
          <FlexContainer className="gap-2" direction="column">
            <span>A new version of the application has been deployed.</span>
            <Button onClick={() => window.location.reload()} size="md" variant="primary">
              <FontAwesomeIcon icon={faArrowsRotate} />
              Refresh page
            </Button>
          </FlexContainer>
        </AlertDescription>
      </Alert>
    </div>
  );
}
